import axios from "axios";
import store from "./store/store";

// Instancia axios contra el API REST (Slim 4): baseURL = .../logistica/api/v1/
let axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});

// Contrato moderno v1 en TODAS las peticiones: exito {data:...} / error {error:{code,message}}
axiosInstance.defaults.headers.common["Accept-Version"] = "v1";

// Request: token JWT en Authorization estandar (antes viajaba en X-Apikey)
axiosInstance.interceptors.request.use(function (config) {
    const token = store.getState().authentication.accessToken;
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Response: 401 con sesion activa => logout global (token vencido/invalido).
// El login (auth/login) tambien responde 401 con credenciales malas; se excluye.
axiosInstance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    const status = error.response ? error.response.status : null;
    const url = (error.config && error.config.url) || "";
    if (status === 401 && url.indexOf("auth/login") === -1 && store.getState().authentication.accessToken) {
        store.dispatch({ type: "LOGOUT_SUCCESS" });
    }
    return Promise.reject(error);
});

// Mensaje legible desde el envelope de error v1 {error:{code,message}}; conserva
// el fallback legacy {mensaje} y los casos sin respuesta (paridad con los catch previos).
export const apiErrorMessage = (error) => {
    if (error.response) {
        const body = error.response.data;
        if (body && body.error && body.error.message) {
            return body.error.message;
        }
        if (body && body.mensaje) {
            return body.mensaje;
        }
        return "Error " + error.response.status + " del servidor";
    }
    if (error.request) {
        return "The request was made but no response was received";
    }
    return error.message;
};

// Descarga autenticada del Excel de un solo uso:
// GET {recurso}/excel/{fileToken}/descarga (blob) -> <a download> con el nombre real.
// Sustituye al iframe hacia dwnExcel.php (publico), que no podia mandar Authorization.
export const descargarExcelPorToken = (recurso, fileToken, nombreArchivo) => {
    return axiosInstance
        .get(recurso + "/excel/" + encodeURIComponent(fileToken) + "/descarga", { responseType: "blob" })
        .then(function (response) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", nombreArchivo || "reporte.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch(function (error) {
            // Con responseType blob el cuerpo del error tambien llega como Blob;
            // se re-lee como JSON para que apiErrorMessage entregue el mensaje v1
            // real (p.ej. 410 "El enlace de descarga expiro...").
            const body = error.response && error.response.data;
            if (body && typeof body.text === "function") {
                return body.text().then(function (texto) {
                    try {
                        error.response.data = JSON.parse(texto);
                    } catch (e) { /* se conserva el mensaje generico */ }
                    throw error;
                });
            }
            throw error;
        });
};

export default axiosInstance;
